/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import mitt from 'mitt';

const Emitter = mitt();
export default Emitter;
